'use client';

import type { ReactElement } from 'react';
import { TbTicket } from 'react-icons/tb';

import type { TicketBlockPayload } from './types';

const PRIORITY_LABEL: Record<string, string> = {
  urgent: 'Urgente',
  high: 'Alta',
  normal: 'Moderada',
  low: 'Leve',
};

export function TicketBlock({ payload }: { payload: TicketBlockPayload }): ReactElement {
  return (
    <div className="border-border-subtle/60 bg-surface-elevated/40 rounded-2xl border p-4">
      <div className="flex items-center gap-3">
        <span className="bg-success/20 text-success flex h-9 w-9 items-center justify-center rounded-lg">
          <TbTicket size={18} />
        </span>
        <div>
          <p className="text-ink text-sm font-bold">Ticket aberto</p>
          <p className="text-ink-muted text-[11px]">{payload.subject}</p>
        </div>
      </div>
      <div className="mt-2 flex flex-wrap gap-1.5">
        <span className="bg-surface-elevated/60 text-ink-muted rounded-full px-2 py-0.5 text-[10px]">
          {PRIORITY_LABEL[payload.priority] ?? payload.priority}
        </span>
        <span className="bg-surface-elevated/60 text-ink-muted rounded-full px-2 py-0.5 text-[10px]">
          Aberto
        </span>
      </div>
      <a
        href={`/suporte/meus-tickets?ticket=${payload.ticket_id}`}
        className="bg-trakd-fill text-on-brand mt-3 inline-block w-full rounded-lg py-2 text-center text-xs font-semibold"
      >
        Acompanhar ticket
      </a>
    </div>
  );
}
